import { SET_ARCHITECTS } from "./actionTypes";
import GetInfoService from "../services/GetInfoService";
import { setAlertMessage } from "./messageAlertAction";
import MessageAlertModel from "../component/MessageAlertComponent/MessageAlertModel";

export const setArchitects = (architects) => {
    return {type: SET_ARCHITECTS, architects};
}

export const getArchitects = () => {
    let infoService = new GetInfoService();
    return (dispatch, getState) => {
        infoService.getArchitects().then((architects) => {
            dispatch(setArchitects(architects));
        }).catch((error) => {
            dispatch(setAlertMessage([new MessageAlertModel({type: "error", title: "Error", message: error.message})]));
        });
    }
}